import { HttpClient, clientName } from "./http-client";
import * as CONST_URL from './common-url'

export const AuthService = {
  login: (user) => {
    return HttpClient.post(CONST_URL.LOGIN_URL(), {
      credential_0: user.username,
      credential_1: user.password,
      destination: `/b2b/${clientName}/index.ext?start=1`
    });
  },
  isLoggedIn: () => {
    return HttpClient.get(CONST_URL.B2b_EXT(), {
      output: 'json',
      section: 'base',
      action: 'is_logged_in'
    });
  },
  fetchUserDetails: () => {
    return HttpClient.get(CONST_URL.B2b_EXT(), {
      output: 'json',
      section: 'base',
      action: 'user_details'
    });
  },
  fetchUserInfo: (userId) => {
    return HttpClient.get(CONST_URL.B2b_EXT(), {
      output: 'json',
      section: 'external_user',
      action: 'ext_user_details',
      external_user_id: userId
    });
  },
  fetchLanguages: () => {
    return HttpClient.get(CONST_URL.B2b_EXT(), {
      output: 'json',
      section: 'administration',
      action: 'languages',

    });
  },
  updatePassword: (user) => {
    return HttpClient.post(CONST_URL.B2b_EXT(), {
      section: 'external_user',
      action: 'update_ext_user',
      ...user
    });
  },
  updateUserInfo: (user) => {
    const userModel = {
      active: user.active,
      created: user.created,
      email: user.email,
      external_only: user.external_only,
      external_user_id: user.external_user_id,
      given_name: user.given_name,
      language: user.language,
      last_modified: user.last_modified,
      mobile: user.mobile,
      permissions: user.permissions,
      phone: user.phone,
      user_name: user.user_name,
    }

    return HttpClient.post(CONST_URL.B2b_EXT(), {
      section: 'external_user',
      action: 'update_ext_user',
      ...userModel
    });
  },
  getResetUserNameUrl: () => {
    return HttpClient.get(CONST_URL.LOGIN_EXT_PL(), {
      recover_username: 1,
      output: 'json',
    });
  },
  getResetPasswordUrl: () => {
    return HttpClient.get(CONST_URL.LOGIN_EXT_PL(), {
      reset_password: 1,
      output: 'json',
    });
  },
  logOut: () => {
    return HttpClient.get2(CONST_URL.EXT_LOGOUT());
  },
}


const invalidRedirectRoutes = ['login', 'logout', 'signup'];
export const isValidRedirectionRoute = (value) => {
  return !invalidRedirectRoutes.includes(value);
}
